import React from "react";
import {useTranslation} from "react-i18next";
import {fixBoldFormatting} from "../helper";

const PrepSteps = ({steps}: {steps: RootObject["metafields"]["steps"]}) => {
  const {t} = useTranslation();

  return <>
    <div className="max-md:pt-4 max-md:px-2">
      <h2>{t("recipe_details.preparation")}</h2>
    </div>
    {steps.map((step, i) => <div key={i} className="flex flex-col md:flex-row md:gap-4">
      <div className="w-full md:w-1/4 flex items-center">
        <img
          className="w-full rounded-2xl aspect-[3/2] object-cover"
          src={step.img}
          alt={step.text}
          loading="lazy"
          width="360"
          height="240"
        />
      </div>
      <div
        className="p-2 md:p-4 w-full md:w-3/4 [&>p>strong]:font-semibold"
        dangerouslySetInnerHTML={{__html: fixBoldFormatting(step.text)}}
      />
    </div>)}
  </>;
};

export {PrepSteps};
